import { AxiosResponse } from 'axios'
import { API_IS_FEATURE_ENABLED } from 'constants/apiUrl'
import { privateInstance } from 'services/axios/privateInstance'

export const isFeatureEnabled = (featureName: string, date?: string) =>
  privateInstance.get<any, AxiosResponse<boolean>>(API_IS_FEATURE_ENABLED, {
    params: { featureName, date },
  })
